import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'
import { useApis } from '../../api/useApiClient';
import { useNotification } from '../../context/NotificationContext';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

import Form from '../Common/Form';
import LoadingDetailsView from '../Common/Skeletons/LoadingDetailsView';

const ItemCategoryForm = ({
    editMode = false,
    type = null // 'PRODUCT' or 'SERVICE' - silently included in form submission
}) => {

    const { tenantApi } = useApis();
    const navigate = useNavigate();
    const { showNotification } = useNotification();

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);

    // load item category data if in edit mode
    const { id } = useParams(); // Get the item ID from the URL parameters if provided (in edit mode)
    const loadformData = async () => {
        setLoading(true);
        try {
            const res = await tenantApi(`/tenants/items/categories/${id}`);
            setFormData({
                name: res?.data?.name,
                type: res?.data?.type,
                description: res?.data?.description,
                isActive: res?.data?.isActive
            });
            console.debug("Item category data loaded successfully:", res?.data);
        } catch (error) {
            console.error("Error loading item category data", error);
            showNotification(error.message || 'Failed to load item category details', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (type !== null && !editMode) {
            setFormData((prevData) => ({ ...prevData, type }));
        }
    }, [type, editMode]);

    useEffect(() => {
        if (editMode) {
            loadformData();
        }
    }, [editMode]);


    // --- Handle input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    // Debug formData update
    useEffect(() => {
        console.debug('Form Data updated: ', formData);
    }, [formData])


    // Show skeliton while loading initial data (if in edit mode)
    if (loading)
        return <LoadingDetailsView />


    return (
        <Box sx={{ padding: { xs: 2, sm: 3 }, maxWidth: '800px' }}>
            <Form
                resourceName='Item Category'
                apiPath='/tenants/items/categories'
                formData={formData}
                requiredFields={
                    [
                        { name: 'name', label: 'Name' },
                    ]
                }
                editMode={editMode}
                onSubmit={() => {
                    navigate(-1);
                }}
                onCancel={() => {
                    navigate(-1);
                }}
            >
                <Stack spacing={3}>
                    {/* Name Group */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Name"
                            name="name"
                            value={formData.name || ''}
                            onChange={handleChange}
                            required
                            fullWidth
                        />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Description"
                            name="description"
                            value={formData.description || ''}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            fullWidth
                        />
                    </Stack>
                </Stack>
            </Form>
        </Box>
    );

};

export default ItemCategoryForm;